import styled from "@emotion/styled";
import { debounce } from "lodash";
import { PureComponent } from "react";

import { SearchInput } from "components/search-input";
import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { isMobileDevice } from "helpers/browser";

import { trackTicketsSearchClearEvent } from "./analytics";

const QUERY_CHANGE_DELAY = 500;

interface IProps {
  searchQuery: string;
  ticketsAreFetching: boolean;
  route: TicketsRoutes;
  onSearchQueryChange(searchQuery: string): void;
  onSearchQueryClear(): void;
}

interface IState {
  inputValue: string;
}

const Wrapper = styled.div`
  padding: 10px 10px 0;
`;

export class TicketsSearchBar extends PureComponent<IProps, IState> {
  state = {
    inputValue: this.props.searchQuery,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    this.handleDebouncedSearchQueryChange.cancel();
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleChange = (inputValue: string) => {
    this.setState({ inputValue }, () => {
      this.handleDebouncedSearchQueryChange(this.state.inputValue);
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSubmit = (inputValue: string) => {
    if (isMobileDevice()) {
      this.props.onSearchQueryChange(inputValue);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSearchQueryChange = (searchQuery: string) => {
    if (!isMobileDevice()) {
      this.props.onSearchQueryChange(searchQuery);
    }
  };

  handleClear = (): void => {
    trackTicketsSearchClearEvent("x in search field");
    this.props.onSearchQueryClear();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isFocusedOnInit() {
    return [TicketsRoutes.Search, TicketsRoutes.All].includes(this.props.route);
  }

  handleDebouncedSearchQueryChange = debounce(this.handleSearchQueryChange, QUERY_CHANGE_DELAY);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { ticketsAreFetching } = this.props;

    return (
      <Wrapper>
        <SearchInput
          value={this.state.inputValue}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          onClear={this.handleClear}
          placeholder="Search in all tickets…"
          focusedOnInit={this.isFocusedOnInit()}
          isLoading={ticketsAreFetching && this.state.inputValue.length > 0}
        />
      </Wrapper>
    );
  }
}
